import styled from 'styled-components';

import { Post } from './Post.jsx';
import { ARCHIVE } from '../Tiles/utils/constants';

export const Posts = ({ posts, id, audienceFilter }) => {
  let campaignTiles = [];

  return (
    <Container>
      {posts.map((post, index) => {
        const tilesByAudience = post.tiles.filter(
          tile =>
            tile.fullyAssembled &&
            tile.tileStatus !== ARCHIVE &&
            (tile.audienceId === null || tile.audienceId === audienceFilter),
        );

        const validTiles = post.tiles.filter(
          tile => tile.fullyAssembled && tile.tileStatus !== ARCHIVE,
        );

        const visibleTiles =
          audienceFilter === 'all' ? validTiles : tilesByAudience;

        campaignTiles = [...visibleTiles, ...campaignTiles];

        return (
          <Post
            campaignId={id}
            key={post.uuid}
            id={post.uuid}
            tiles={visibleTiles}
            campaignTiles={campaignTiles}
            publishDate={post.publishDate}
            postIndex={index}
            status={post.status}
          />
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;
